import { makeTssStyles } from "@app/components/tss/tss";

export const useStyles = makeTssStyles<
  void,
  "icon" | "severityNotice" | "severityNegative"
>({
  name: "TransferMessage",
  uniqId: "L4rizy"
})((theme, _params, classes) => {
  const { colors, spacing, styles } = theme.busbud;
  return {
    container: {
      margin: spacing(0.5, 0),
      borderRadius: styles.rounding.lg,
      [`&.${classes.severityNotice}`]: {
        color: colors.text.notice.opaque,
        backgroundColor: colors.background.notice.transparent,
        [`& .${classes.icon}`]: {
          color: colors.icon.notice.opaque
        }
      },
      [`&.${classes.severityNegative}`]: {
        color: colors.text.negative.opaque,
        backgroundColor: colors.background.negative.transparent,
        [`& .${classes.icon}`]: {
          color: colors.icon.negative.opaque
        }
      }
    },
    icon: {
      display: "grid",
      placeItems: "center",
      height: "100%",
      marginLeft: spacing(1.5)
    },
    checkpointPath: {
      padding: spacing(0.75, 0)
    },
    content: {
      padding: spacing(1.5, 0)
    },
    indent: {
      height: spacing(3)
    },
    severityNotice: {},
    severityNegative: {}
  };
});
